import _taggedTemplateLiteral from "/home/runner/work/is-eth-congested-website/is-eth-congested-website/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import styled from 'styled-components';
import { Typography } from '@material-ui/core';
var Title = styled(Typography)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-bottom: 12px;\n  font-weight: bold;\n  ", "\n"])), function (_ref) {
  var theme = _ref.theme;
  return "\n    color: ".concat(theme.palette.primary.contrastText, ";\n    filter: brightness(75%);\n  ");
});
var Container = styled.section(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 12px 0px;\n  ", "\n"])), function (_ref2) {
  var isInline = _ref2.isInline;
  return "\n    width: ".concat(isInline ? '100%' : 'auto', ";\n  ");
});
var List = styled.ul(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  list-style-type: none;\n  padding 0;\n  margin: 0;\n  display: flex;\n  justify-content: center;\n  flex-wrap: wrap;\n  ", "\n"])), function (_ref3) {
  var isInline = _ref3.isInline;
  return "\n    flex-direction: ".concat(isInline ? 'row' : 'column', ";\n    justify-content: space-evenly;\n    width: ").concat(isInline ? '100%' : 'auto', ";\n  ");
});

var Column = function Column(_a) {
  var children = _a.children,
      _a$isInline = _a.isInline,
      isInline = _a$isInline === void 0 ? false : _a$isInline,
      title = _a.title,
      rest = __rest(_a, ["children", "isInline", "title"]);

  return React.createElement(Container, Object.assign({
    isInline: isInline
  }, rest), title && React.createElement(Title, null, title), children && React.createElement(List, {
    isInline: isInline
  }, children));
};

Column.displayName = 'Footer.Column';
var ColumnExtra = styled(Column)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral([""])));
export default ColumnExtra;